<template>
  <span
    @click="clickLink()"
    :class="{
      'cursor-pointer': isEnableLink && preview
    }"
  >
    <slot></slot>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      linkType1: ["url", "page", "anchor"],
      linkType2: ["phone", "email", "file"],
    };
  },
  props: {
    linkProps: {
      type: Object,
      default() {
        return {};
      },
    },
    isEnableLink: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      siteComponents: "designIframe/metadata/siteComponents",
      sitePage: "designIframe/metadata/sitePage",
    }),
  },
  methods: {
    clickLink() {
      if (this.preview && this.isEnableLink) {
        switch (this.linkProps.type) {
          case "url": {
            if (this.checkCanClick()) {
              let hrefFormat = this.$helper.url.genValidUrl(this.linkProps.url);

              window.open(hrefFormat, this.linkProps.target);
            } else {
              this.$emit("setPopover", true);
            }
            break;
          }
          case "page": {
            if (this.checkCanClick()) {
              let metaDataID =
                this.siteComponents[this.linkProps.pageID].properties
                  .metaDataID;
              if (this.sitePage.properties.metaDataID != metaDataID) {
                this.$store.dispatch("designIframe/page/getPage", {
                  metaDataID,
                });
              } else {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }
            } else {
              this.$emit("setPopover", true);
            }
            break;
          }
          case "anchor": {
            if (this.checkCanClick()) {
              let metaDataID =
                this.siteComponents[this.linkProps.sectionPageID].properties
                  .metaDataID;
              let elementID = this.linkProps.sectionID;

              this.setNewHashJs(metaDataID, elementID);
              this.$store.dispatch("designIframe/page/getPage", {
                metaDataID,
                elementID,
              });
            } else {
              this.$emit("setPopover", true);
            }
            break;
          }
          case "phone": {
            let hrefFormat = `tel:${this.linkProps.phoneFormat}`;
            window.open(hrefFormat, "_self");
            break;
          }
          case "email": {
            let hrefFormat =
              `mailto:${this.linkProps.email}` +
              (this.linkProps.emailSubject
                ? `?subject=${this.linkProps.emailSubject}`
                : ``);
            window.open(hrefFormat, "_self");
            break;
          }
          case "file": {
            if (
              this.linkProps.fileUrl != null &&
              this.linkProps.fileName != null
            ) {
              let hrefFormat = `${this.linkProps.fileUrl}`;
              let arr = this.linkProps.fileName.split(".");
              let ext = arr[1];
              if (ext == "pdf" || ext == "txt") {
                window.open(hrefFormat, "_blank");
              } else {
                window.open(hrefFormat, "_self");
              }
            }

            break;
          }
          default: {
            break;
          }
        }
      }
    },
    checkCanClick() {
      if (this.linkProps.type == "url" && this.linkProps.target == "_self") {
        return false;
      } else if (
        this.linkProps.type == "page" &&
        this.linkProps.target == "_blank"
      ) {
        return false;
      } else {
        return true;
      }
    },
    setNewHashJs(metaDataID, elementID = null) {
      let url = `#/page/${metaDataID}/anchor/${elementID}`;
      this.$store.dispatch(
        "designIframe/postToParent",
        {
          func: "component/setNewHashJs",
          payload: {
            url: url,
          },
        },
        { root: true }
      );
    },
  },
};
</script>

<style lang="scss">
.pointer {
  cursor: pointer;
}
</style>
